import React from "react";
import "./MetaAdsStatCard.style.scss";

const MetaAdsStatCard = ({ title, value, subLabel, valueColor = "#222", subLabelColor = "#8E8E93" }) => (
  <div className="meta-ads-stat-card">
    <div className="meta-ads-stat-title">{title}</div>
    <div className="meta-ads-stat-value" style={{ color: valueColor }}>{value}</div>
    <div className="meta-ads-stat-sublabel" style={{ color: subLabelColor }}>{subLabel}</div>
  </div>
);

export default MetaAdsStatCard;
